module.exports = __webpack_public_path__ + "img/Banner-Zendai.d1aff51d.png";